import { SET_PAGE_HEADER } from "../mutations.type";
import i18n from "@/plugins/i18n";

export const state = {
  pageTitle: "",
  backScreen: "",
  btnBackText: i18n.t("button.back"),
};

export const actions = {};

export const mutations = {
  [SET_PAGE_HEADER](state, [pageTitle, backScreen, btnBackText]) {
    state.pageTitle = pageTitle;
    if (backScreen) state.backScreen = backScreen;
    if (btnBackText) state.btnBackText = state.btnBackText;
  },
};

const getters = {
  pageTitle(state) {
    return state.pageTitle;
  },
  backScreen(state) {
    return state.backScreen;
  },
  btnBackText(state) {
    return state.btnBackText;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
